import type { StoreObject } from '@apollo/client';
import type { TypePolicies } from '../../../utils/types/TypePolicies';

type ResultType = 'QuickSearchAssetResult' | 'QuickSearchProjectResult';

const makeResultCacheKey =
  (prefix: ResultType) => (object: Readonly<StoreObject>) => {
    const result = object.result as { __ref?: string } | undefined;
    if (!result?.__ref) return false;

    const [__, id] = result.__ref.split(':');
    return `${prefix}:${id}`;
  };

export const typePolicies: TypePolicies = {
  AssetResult: {
    keyFields: makeResultCacheKey('QuickSearchAssetResult'),
  },
  ProjectResult: {
    keyFields: makeResultCacheKey('QuickSearchProjectResult'),
  },
};
